import type { ZodError, ZodTypeDef, ZodType } from "zod";

// If this ever needs to be updated zod has some helpful description of how to
// write generic functions.
// https://github.com/colinhacks/zod#writing-generic-functions
export const zodSafeParseMap =
  <A, ZOutput, ZDef extends ZodTypeDef = ZodTypeDef, ZInput = ZOutput>(
    zod: ZodType<ZOutput, ZDef, ZInput>,
    map: {
      mapValid: (data: ZOutput) => A;
      mapError: (error: ZodError<ZInput>) => A;
    }
  ) =>
  (data: unknown): A => {
    const parsed = zod.safeParse(data);
    return parsed.success
      ? map.mapValid(parsed.data)
      : map.mapError(parsed.error);
  };
